export interface AchievementDef {
  id: string;
  title: string;
  description: string;
  category: "volume" | "project" | "community" | "streaks";
  threshold?: number;
  credits: number;
  icon: string;
  /** If true, unlocking this achievement grants a displayable badge */
  hasBadge?: boolean;
}

export const ACHIEVEMENTS: AchievementDef[] = [
  // Volume (user-written words only)
  { id: "words-1k", title: "First Thousand", description: "Write 1,000 words by hand", category: "volume", threshold: 1000, credits: 100, icon: "✍️", hasBadge: true },
  { id: "words-5k", title: "Getting Serious", description: "Write 5,000 words by hand", category: "volume", threshold: 5000, credits: 200, icon: "📝" },
  { id: "words-10k", title: "Five Figures", description: "Write 10,000 words by hand", category: "volume", threshold: 10000, credits: 300, icon: "📖", hasBadge: true },
  { id: "words-25k", title: "Quarter Novel", description: "Write 25,000 words by hand", category: "volume", threshold: 25000, credits: 500, icon: "📚", hasBadge: true },
  { id: "words-50k", title: "NaNoWriMo", description: "Write 50,000 words by hand", category: "volume", threshold: 50000, credits: 1000, icon: "🏆", hasBadge: true },
  { id: "words-100k", title: "Centurion", description: "Write 100,000 words by hand", category: "volume", threshold: 100000, credits: 2000, icon: "👑", hasBadge: true },

  // Project
  { id: "first-project", title: "Origin Story", description: "Create your first project", category: "project", credits: 100, icon: "🌱", hasBadge: true },
  { id: "first-chapter", title: "First Chapter", description: "Write a chapter file", category: "project", credits: 100, icon: "📄" },
  { id: "three-projects", title: "Multi-threaded", description: "Create 3 projects", category: "project", threshold: 3, credits: 200, icon: "🗂️" },
  { id: "first-review", title: "Under the Lens", description: "Complete a Draft Review", category: "project", credits: 200, icon: "🔍", hasBadge: true },
  { id: "first-audience", title: "Focus Group", description: "Complete an Audience Test", category: "project", credits: 200, icon: "🎯" },
  { id: "first-bible", title: "Worldbuilder", description: "Generate a Story Bible", category: "project", credits: 200, icon: "🗺️", hasBadge: true },

  // Community
  { id: "first-post", title: "Voice Found", description: "Publish first community post", category: "community", credits: 100, icon: "📣", hasBadge: true },
  { id: "first-challenge", title: "Challenge Accepted", description: "Submit your first challenge entry", category: "community", credits: 120, icon: "🏅", hasBadge: true },
  { id: "three-challenges", title: "Prompt Explorer", description: "Submit 3 challenge entries", category: "community", threshold: 3, credits: 250, icon: "🧭" },
  { id: "first-comment-received", title: "Conversation Starter", description: "Receive a comment on your post", category: "community", credits: 100, icon: "💬" },
  { id: "ten-followers", title: "Small Following", description: "Reach 10 followers", category: "community", threshold: 10, credits: 300, icon: "👥", hasBadge: true },
  { id: "fifty-followers", title: "Growing Audience", description: "Reach 50 followers", category: "community", threshold: 50, credits: 500, icon: "🌟", hasBadge: true },

  // Streaks
  { id: "streak-3", title: "Warming Up", description: "3-day writing streak", category: "streaks", threshold: 3, credits: 100, icon: "🔥" },
  { id: "streak-7", title: "Weekly Warrior", description: "7-day writing streak", category: "streaks", threshold: 7, credits: 200, icon: "⚡", hasBadge: true },
  { id: "streak-30", title: "Monthly Machine", description: "30-day writing streak", category: "streaks", threshold: 30, credits: 600, icon: "💎", hasBadge: true },
];

export const ACHIEVEMENT_MAP = new Map(ACHIEVEMENTS.map((a) => [a.id, a]));

export const getAchievement = (id: string) => ACHIEVEMENT_MAP.get(id) ?? null;

export const ACHIEVEMENT_CATEGORIES = ["volume", "project", "community", "streaks"] as const;

export const CATEGORY_LABELS: Record<string, string> = {
  volume: "Volume",
  project: "Project",
  community: "Community",
  streaks: "Streaks",
};

export const BADGE_ACHIEVEMENTS = ACHIEVEMENTS.filter((a) => a.hasBadge);
export const BADGE_ACHIEVEMENT_IDS = new Set(BADGE_ACHIEVEMENTS.map((a) => a.id));

export const COMMUNITY_CHALLENGE_ACTIVE = true;
export const COMMUNITY_CHALLENGE_TEXT = "Community Challenge: Best Post This Month — Win 10,000 bonus credits";
export const COMMUNITY_CHALLENGE_CTA = "Join the Challenge";
